import type { ControlListItem, ControlTag } from "@/models/control.model";
import { SearchableSelect } from "@spz/ui/components/searchable-select";
import type { Table } from "@tanstack/react-table";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

type ControlListTagsFiltersProps = {
  uniqueTags: ControlTag[];
  table: Table<ControlListItem>;
};

export const ControlListTagsFilters = ({
  table,
  uniqueTags,
}: ControlListTagsFiltersProps) => {
  const { t } = useTranslation();

  const filteredTags = (table.getColumn("tags")?.getFilterValue() ??
    []) as string[];

  const options = useMemo(
    () =>
      uniqueTags.map((tag) => ({
        label: String(tag.name),
        value: String(tag.id),
      })),
    [uniqueTags],
  );

  const onFilterChange = (newTags: string[]) => {
    table.setColumnFilters((current) => {
      const filtered = current.filter((f) => f.id !== "tags");
      return [...filtered, { id: "tags", value: newTags }];
    });
  };

  return (
    <SearchableSelect
      placeholder={t("tags")}
      className="h-6"
      options={options}
      value={filteredTags}
      onSelect={onFilterChange}
      multi
      variant="ghost"
      data-testid="filter-tags-button"
    />
  );
};
